"use strict";

exports.__esModule = true;
var ExtendedDateFilters;

(function (ExtendedDateFilters) {
  ExtendedDateFilters.isAllTimeDateFilter = function (option) {
    return option ? option.type === 'allTime' : false;
  };

  ExtendedDateFilters.isAbsoluteDateFilterForm = function (option) {
    return option ? option.type === 'absoluteForm' : false;
  };

  ExtendedDateFilters.isAbsoluteDateFilterPreset = function (option) {
    return option ? option.type === 'absolutePreset' : false;
  };

  ExtendedDateFilters.isAbsoluteDateFilterOption = function (option) {
    return ExtendedDateFilters.isAbsoluteDateFilterForm(option) || ExtendedDateFilters.isAbsoluteDateFilterPreset(option);
  };

  ExtendedDateFilters.isRelativeDateFilterForm = function (option) {
    return option ? option.type === 'relativeForm' : false;
  };

  ExtendedDateFilters.isRelativeDateFilterPreset = function (option) {
    return option ? option.type === 'relativePreset' : false;
  };

  ExtendedDateFilters.isRelativeDateFilterOption = function (option) {
    return ExtendedDateFilters.isRelativeDateFilterForm(option) || ExtendedDateFilters.isRelativeDateFilterPreset(option);
  };
})(ExtendedDateFilters = exports.ExtendedDateFilters || (exports.ExtendedDateFilters = {}));